// #ux-redesign-start: SectionCard primitive (Paso 2)
// Tarjeta con header opcional, para sub-secciones dentro de un PageContainer.
// Soporta collapsible para vistas largas tipo Settings.
//
// PORTABILIDAD: trasplantable a Web-Patients.
//
// USO:
//   <SectionCard title="Personliche Daten">
//     {fields}
//   </SectionCard>
//
//   <SectionCard
//     title="Erweiterte Einstellungen"
//     description="Nur fur Administratoren"
//     collapsible
//     defaultCollapsed
//     actions={<Button variant="tertiary" size="sm">Bearbeiten</Button>}
//   >
//     {advancedFields}
//   </SectionCard>
// ─────────────────────────────────────────────────────────────────────────────

import React, { useState } from 'react';
import PropTypes from 'prop-types';

const SectionCard = ({
  title,
  description,
  icon,
  actions,
  collapsible = false,
  defaultCollapsed = false,
  children,
  className = '',
  bodyClassName = '',
}) => {
  const [collapsed, setCollapsed] = useState(defaultCollapsed);
  const showHeader = Boolean(title || actions);

  const toggle = () => collapsible && setCollapsed(!collapsed);

  const classes = [
    'ds-section',
    collapsible ? 'ds-section--collapsible' : '',
    collapsed ? 'ds-section--collapsed' : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <section className={classes}>
      {showHeader && (
        <header className="ds-section__header">
          <div
            className={`ds-section__heading ${collapsible ? 'ds-section__heading--clickable' : ''}`}
            onClick={collapsible ? toggle : undefined}
            role={collapsible ? 'button' : undefined}
            tabIndex={collapsible ? 0 : undefined}
            aria-expanded={collapsible ? !collapsed : undefined}
            onKeyDown={collapsible ? (e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                toggle();
              }
            } : undefined}
          >
            {icon && <span className="ds-section__icon" aria-hidden="true">{icon}</span>}
            <div>
              {title && <h2 className="ds-section__title">{title}</h2>}
              {description && <p className="ds-section__description">{description}</p>}
            </div>
            {collapsible && (
              <span className="ds-section__chevron" aria-hidden="true">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="6 9 12 15 18 9" />
                </svg>
              </span>
            )}
          </div>
          {actions && <div className="ds-section__actions">{actions}</div>}
        </header>
      )}
      {!collapsed && (
        <div className={`ds-section__body ${bodyClassName}`}>
          {children}
        </div>
      )}
    </section>
  );
};

SectionCard.propTypes = {
  title: PropTypes.node,
  description: PropTypes.node,
  icon: PropTypes.node,
  actions: PropTypes.node,
  collapsible: PropTypes.bool,
  defaultCollapsed: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  bodyClassName: PropTypes.string,
};

export default SectionCard;
// #ux-redesign-end
